export default "__VITE_PUBLIC_ASSET__2eaf41b8__"